EventEmitter = require 'eventemitter3'

class LayoutSequencer extends EventEmitter

  constructor: ->
    @init()

  init: ->

    @$win  = $(window)
    @$body = $('body')

    @state =
      currentLayout: null

    # media判定用のエレメント作成
    @$mediaState = $('<div class="mediaState">').css
      height: 0
      width: 0
      position: 'absolute'
      left: -9999
    @$body.append(@$mediaState)

    @checkLayout()
    @$win.on 'resize', @checkLayout


  checkLayout: =>
    if @$mediaState.css('background-color') == 'rgb(255, 0, 0)'
      if @state.currentLayout == 'layout1'
        return false
      @$body.removeClass('is-layout2 is-layout3').addClass('is-layout1')
      @state.currentLayout = 'layout1'
      @emit 'change', @state

    else if @$mediaState.css('background-color') == 'rgb(0, 255, 0)'
      if @state.currentLayout == 'layout2'
        return false
      @$body.removeClass('is-layout1 is-layout3').addClass('is-layout2')
      @state.currentLayout = 'layout2'
      @emit 'change', @state

    else if @$mediaState.css('background-color') == 'rgb(0, 0, 255)'
      if @state.currentLayout == 'layout3'
        return false
      @$body.removeClass('is-layout1 is-layout2').addClass('is-layout3')
      @state.currentLayout = 'layout3'
      @emit 'change', @state

    else
      # for ie8
      if @state.currentLayout == 'layout1'
        return false
      @$body.removeClass('is-layout2 is-layout3').addClass('is-layout1')
      @state.currentLayout = 'layout1'
      @emit 'change', @state

  getLayout: ->
    return @state.currentLayout


module.exports = LayoutSequencer



// WEBPACK FOOTER //
// ./src/scripts/modules/LayoutSequencer.coffee